import React, { useState } from "react";
import { Form, Row, Col, Button, InputGroup, Spinner } from "react-bootstrap";
import { autocompleteSearch } from "./api";

const SearchBar = ({ query, setQuery, executeSearch }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ---------------------------------------------
     HANDLE TYPING
  --------------------------------------------- */
  const handleInput = async (value) => {
    setQuery(value);

    if (value.length < 2) {
      setSuggestions([]);
      return;
    }

    setLoading(true);
    try {
      const res = await autocompleteSearch(value);
      const live =
        res.data?.details?.getProductsInfoResponse?.productInfoList?.productInfo || [];
      const mapped = live.map((item) => ({
        reference: item.reference || item.id || "",
        name: item.name || "",
        brand: item.producer || "",
        category: item.groupName || "",
      }));
      setSuggestions(mapped);
    } catch (err) {
      console.error("Autocomplete failed", err);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------------------------------------
     CLICK SUGGESTION
  --------------------------------------------- */
  const handleSuggestionClick = (item) => {
    setQuery(item.reference || "");
    setSuggestions([]);
    executeSearch(item.reference);
  };

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        executeSearch(query);
      }}
      className="p-3 rounded-4 shadow-sm mb-4"
      style={{
        background: "rgba(13,110,253,.06)",
        border: "1px solid rgba(13,110,253,.15)",
        backdropFilter: "blur(4px)"
      }}
    >
      <Row className="g-2 align-items-center">
        <Col xs={12} md={9}>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Search OEM, Reference, TecDoc…"
              value={query}
              onChange={(e) => handleInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && executeSearch(query)}
              style={{
                background: "rgba(255,255,255,.95)",
                padding: "12px 14px"
              }}
            />

            <Button type="submit" variant="primary" className="fw-semibold">
              {loading ? <Spinner size="sm" animation="border" /> : "Search"}
            </Button>
          </InputGroup>

          {suggestions.length > 0 && (
            <div
              className="position-absolute bg-white rounded shadow-sm mt-1 w-100"
              style={{ zIndex: 1000 }}
            >
              {suggestions.map((s, i) => (
                <div
                  key={i}
                  className="p-2 border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSuggestionClick(s)}
                >
                  <strong>{s.reference}</strong> — {s.name}
                  <div className="text-muted small">
                    {s.brand} · {s.category}
                  </div>
                </div>
              ))}
            </div>
          )}
        </Col>

        <Col xs={12} md={3}>
          <Button
            variant="outline-secondary"
            className="w-100 fw-semibold"
            onClick={() => {
              setQuery("");
              setSuggestions([]);
            }}
          >
            Clear
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default SearchBar;
